<template lang="html">
  <div id="data-list-list-view" class="data-list-container">
    <!--<div v-if="$apollo.loading">
      <div :class="{'activeLoading':activeLoading}" id="loading-default"
           class="vs-con-loading__container loading-example"></div>
    </div>-->
    <vs-table
      :sst="true"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
      v-model="selected"
      :total="allChangeReqAppl.total"
      pagination
      max-items="20"
      :data="allChangeReqAppl.data">
      <template slot="header">
        <h3>
          Change Request From Head Office
        </h3>
      </template>
      <template slot="thead">
        <vs-th sort-key="email">
          ID
        </vs-th>
        <vs-th sort-key="email">
          Name
        </vs-th>
        <vs-th sort-key="email">
          Phone
        </vs-th>
        <vs-th sort-key="email">
          HO Comments
        </vs-th>
        <vs-th sort-key="email">
          Status
        </vs-th>
        <vs-th sort-key="id">
          Action
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].id">
            {{paddingId((data[indextr].id).toString())}}
          </vs-td>
          <vs-td :data="data[indextr].ho_comments">
            {{data[indextr].user.ekyc.parsonal.name}}
          </vs-td>

          <vs-td :data="data[indextr].ho_comments">
            {{data[indextr].user.ekyc.phone}}
          </vs-td>

          <vs-td :data="data[indextr].ho_comments">
            {{data[indextr].ho_comments}}
          </vs-td>

          <vs-td :data="data[indextr].status">
            <vs-chip color="success" class="product-order-status">{{data[indextr].status =='5'?
              'Accepted':'Accepted'}}
            </vs-chip>
          </vs-td>
          <feather-icon icon="EyeIcon" @click="applicationDetal(data[indextr].id)"
                        svgClasses="w-5 h-5 hover:text-success stroke-current"
                        class="ml-2 mt-2 clickable"/>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>


  import { ME } from '../../graphql/userinfo'
  import {mapGetters} from 'vuex'

  export default {
    data () {
      return {
        totalItems: 0,
        selected: [],
        selectedPgae: 1,
        itemsPerPage: 7,
        isMounted: false,
        pagination: '',
        applicationList: [],
        // Data Sidebar
        addNewDataSidebar: false,
        sidebarData: {},
        activeLoading: false,
        pdfFile:'',
        popupActive2: false,
        updateId:'',
        invoiceNumber:'',
        userInfo: {
          ekyc:{
            status:''
          }
        },
      }
    },
    apollo: {
      user: {
        query: ME,
        manual: true,
        result ({ data, loading }) {
          if (!loading) {
            this.userInfo = data.me

          }
        }
      }
    },

    created(){

      this.$apollo.queries.user.refetch();

      this.$store.dispatch('getChangeReqApplLists', `9/${this.userInfo.id}`);

    },
    watch: {

    },
    async mounted(){
      this.$store.dispatch('getChangeReqApplLists', `9/${this.userInfo.id}`);
    },
    computed: {
      ...mapGetters(['allChangeReqAppl']),
      /*currentPage () {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },*/
      /*products () {
        //return this.$store.state.dataList.products
      },*/
      /*queriedItems () {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      }*/
    },
    methods: {

      applicationDetal(id) {
        this.$router.push('/application-details/' + id).catch(() => { })
      },
      handleChangePage(page) {
        this.selectedPgae = page;
        this.$store.dispatch('getChangeReqApplLists', `9/${this.userInfo.id}`+'?page=' + this.selectedPgae);
      },

      paddingId(id){
        console.log("--------->",id.toString().length);
        if(id.toString().length === 1){return 'A000000000'+id;}
        else if(id.toString().length === 2){return 'A00000000'+id;}
        else if(id.toString().length === 3){return 'A0000000'+id;}
        else if(id.toString().length === 4){return 'A000000'+id;}
        else if(id.toString().length === 5){return 'A00000'+id;}
        else if(id.toString().length === 6){return 'A0000'+id;}
        else if(id.toString().length === 7){return 'A000'+id;}
        else if(id.toString().length === 8){return 'A00'+id;}
        else if(id.toString().length === 9){return 'A'+id;}
        else if(id.toString().length === 10){return id;}

      },
      downloadAgreement(id){
        this.pdfFile =  "https://showroom.butterflygroupbd.com/showroom-backend/storage/agreement_"+id+".pdf";
        return window.open(this.pdfFile);
      },
    },
  }
</script>


<style lang="scss">
  .clickable {
    cursor: pointer;
  }

  img.product-img.butterfly-product {
    height: 40px;
    width: auto;
  }

  .vs-table--not-data {
    display: none;
  }

  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }


  .fill-row-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    .loading-example {
      width: 120px;
      float: left;
      height: 120px;
      box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      margin: 8px;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.05);
        transform: translate(0, 4px);
      }

      h4 {
        z-index: 40000;
        position: relative;
        text-align: center;
        padding: 10px;
      }

      &.activeLoading {
        opacity: 0 !important;
        transform: scale(0.5);
      }
    }
  }


</style>
